<template>

    <div>

        <!-- MODAL WINDOW -->
        <modal
            :title="$t('CPC-IMAGE_POOL-MODAL-TITLE')"
            transition="slideDown"
            cancel-text="schließen"
            :show-ok="false"
            :backdrop-closable="false"
            :is-show="showModal"
            @close="modalClose"
            class="imagePool vcenter">

            <template v-if="articleId != null">

                <strong><lang labelKey="CPC-IMAGE_POOL-ASSIGNED_IMAGES"></lang></strong>

                <template v-if="!this.singleImage && assignedAssets.length > 0">
                    <p-check class="p-switch p-slim" color="info" v-model="markAll">alle auswählen</p-check>
                </template>

                <template v-if="assignedAssets.length > 0">
                    <div class="images assigend" style="margin: 5px 0 25px 0;">
                        <div v-for="(image, index) in assignedAssets" :class="['imgWrapper lazy-img-fadein', { 'selected': image.isSelected == true }]" v-lazy:background-image="imagePath(image.asset)" @click="imageSelect(image, index)">
                            <div class="overlay" v-if="image.isSelected">
                                <span class="icon"><i class="fa fa-check"></i></span>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-else>
                    <div style="margin: 5px 0 25px 0;">Für diesen Beitrag wurden noch keine Bilder angelegt</div>
                </template>

            </template>

            <template v-if="imagePoolEntire.length > 0">

                <strong><lang labelKey="CPC-IMAGE_POOL-SEARCH"></lang></strong>
                <form-input type="text" v-model="imagePoolSearch" placeholder="Stichwort, Dateiname, ..."></form-input>

                <div class="images" v-if="imagePoolSearchResult.length > 0">
                    <div v-for="(image, index) in imagePoolSearchResult" :class="['imgWrapper lazy-img-fadein', { 'selected': image.isSelected == true }]" :key="image.id" v-lazy:background-image="imagePath(image)" @click="imageSelect(image, index, true)">
                        <div class="overlay" v-if="image.isSelected">
                            <span class="icon"><i class="fa fa-check"></i></span>
                        </div>
                    </div>
                </div>

                <div v-else>

                    <i>keine Ergebnisse gefunden ...</i>

                </div>

            </template>

            <div slot="footer">
                <span class="button" @click="modalClose">abbrechen</span>
                <span :class="['button is-success', { 'is-disabled': imagesSelected.length == 0 }]" @click="imagesAccept">übernehmen</span>
            </div>

        </modal>

    </div>

</template>


<script>
import Vue from 'vue';
// https://lokesh-coder.github.io/pretty-checkbox/
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

export default {

    props: {

        assets: {
            type: Array,
            default: function() { return [] }
        },
        articleId: {
            type: Number,
            default: null
        },
        singleImage: {
            type: Boolean,
            default: true
        },
        show: {
            type: Boolean,
            default: false
        }

    },


    data() {

        return {
          showModal: false,
          isLoading: false,
          article: null,
          markAll: false,
          assignedAssets: [],
          imagesSelected: [],
          imagePoolArticle: [],
          imagePoolEntire: [],
          imagePoolSearch: ''
        }
        
    },

    computed: {

      imagePoolSearchResult() {

  			var arr = [];

  			for(let i in this.imagePoolEntire) {

  				if(arr.length >= 10) {
  					return arr;
  				}

                  var search = this.imagePoolSearch.trim().toLowerCase();

                  if(this.imagePoolEntire[i].tags != null && this.imagePoolEntire[i].tags.toLowerCase().indexOf(search) > -1
  					|| this.imagePoolEntire[i].caption != null && this.imagePoolEntire[i].caption.toLowerCase().indexOf(search) > -1) {
  						arr.push(this.imagePoolEntire[i]);
  					}

  			}

  			return arr;

	    },


    },

    watch: {

        markAll(newVal) {

            var self = this;

            if(newVal == true) {
                this.assignedAssets.forEach((image, index) => { self.imageSelect(image, index); });
            } else {
                this.imagesSelected = [];
                this.assignedAssets.forEach((image) => { image.isSelected = false });
            }

        },

        show(newVal) {

            this.showModal = newVal;

            if(newVal == true) {
                this.imagesSelected = [];
                this.assignedAssets.forEach((image) => { image.isSelected = false });
                this.fetchData();
            }
        },

    },


    created() {

        this.assignedAssets = this.assets;

    },

    methods: {


        imagePath(asset) {

            if(asset == null) {
                return false;
            }

            return this.$config.assets + asset.path + '/thumb/' + asset.filename;

        },

        imageSelect(image, index, newObject=false) {


            if(this.singleImage && this.imagesSelected.length == 1 && !image.isSelected) {
                this.$notify.open({ content: 'Sie können nur ein Bild auswählen', type: 'warning'});
                return false;
            }

            if(newObject) {

                // in case the image already was selected, we de-select it
                if(image.isSelected) {

                    this.$set(this.imagePoolEntire[index], 'isSelected', false);

                    // remove the image from our temp array
                    this.imagesSelected.splice(this.imagesSelected.findIndex(i => i.asset.id == image.id), 1);
                    return;

                // otherwise we add it to the "imagesSelected" Array
                } else {

                    // remove the "is selected" flag from all assets
                    if(this.singleImage) {

                        this.imagePoolEntire.forEach(image => image.isSelected = false);
                        this.imagesSelected = [];

                    }

                    // add the "is selected" flag to the selected image
                    this.$set(this.imagePoolEntire[index], 'isSelected', true);

                    // prepare our new omg obj
                    let imgObj = {
                        article: this.articleId,
                        asset: image,
                        isDefault: false
                    }

                    this.imagesSelected.push(imgObj);

                }


            } else {

                if(image.isSelected == true) {

                    // set "isSelected" flag to false
                    this.$set(this.assignedAssets[index], 'isSelected', false);

                    // remove the image from our temp array
                    this.imagesSelected.splice(this.imagesSelected.findIndex(i => i.id == image.id), 1);
                    return;

                }

                this.$set(this.assignedAssets[index], 'isSelected', true);
                this.imagesSelected.push(image);

            }

        },

        imagesAccept() {

            this.$emit('selectImage', this.imagesSelected);

            this.markAll = false;
            this.imagePoolEntire.forEach(image => image.isSelected = false );

        },

        modalClose() {

            this.markAll = false;
            this.imagePoolEntire.forEach(image => image.isSelected = false );

            this.$emit('close');

        },

        fetchData() {

            this.isLoading = true;

            if(this.imagePoolEntire.length > 0) {
                this.isLoading = false;
                return false;
            }

            var self = this;
            var exclude = "";


            /*
            if(this.assets.length > 0) {

                var excludeIds = [];
                this.assets.forEach(function(asset) {
                    excludeIds.push('!'+asset.asset.id);
                })

                exclude = '&filters[asset.id]='+excludeIds.join(',');

            } else {
                exclude = "";
            }


            var helper = [];


            this.axios.get(this.$config.api + 'articleAsset?include=articleAsset.asset'+exclude)
                .then(function(response) {

                    // make sure we don't add the same asset twice
                    response.data.articleAsset.forEach(function(asset) {
                        if(helper.indexOf(asset.asset.id) == -1) {
                            helper.push(asset.asset.id);
                            self.imagePoolEntire.push(asset);
                        }
                    })

                    self.isLoading = false;

                });

            */

            var helper = [];

            this.axios.get(this.$config.api + 'asset?filters[path]=article')
                .then(function(response) {

                    // make sure we don't add images which are in our "assignedAssets" array already
                    response.data.asset.forEach(asset => {
                        if(helper.indexOf(asset.id) == -1 && self.assignedAssets.findIndex(a => { return a.asset.id == asset.id }) == -1) {
                            helper.push(asset.id);
                            self.imagePoolEntire.push(asset);
                        }
                    })

                    // console.log("imagePoolEntire: ", self.imagePoolEntire);
                    // console.log("assignedAssets: ", self.assignedAssets);

                    self.isLoading = false;
                    helper = [];
                });


        }
    }


}

</script>


<style lang="scss">
    @import '~pretty-checkbox/src/pretty-checkbox.scss';
</style>

<style scoped>

    >>> .p-switch {
        margin-left: 12px;
    }
	/* modal */
	.modal.imagePool >>> .modal-card {
		width: 100% !important;
		min-width: 640px !important;
		max-width: 860px !important;
	}
	.modal.imagePool >>> .images {
		display: flex;
		flex-wrap: wrap;
        background: #F5F7F9;
        overflow-y: auto;
        padding: 5px;
        max-height: 160px;
	}
	.modal.imagePool >>> .images .imgWrapper {
        position: relative;
		background-repeat: no-repeat;
	    background-position: 50% 50% !important;
	    background-size: cover;
	    height: 60px;
		width: 80px;
	    margin: 0;
	    background-color: #FFF;
	    border: 1px solid #aaa;
	    border-radius: 3px;
		cursor: pointer;
		transition: all .3s ease;
		margin: 4px;
	}
    .modal.imagePool >>> .images.assigend .imgWrapper {
        height: 60px;
        width: 80px;
	}
	.modal.imagePool >>> .images .imgWrapper[lazy=loading]  {
		background-size: 25% !important;
	}
	.modal.imagePool >>> .images .imgWrapper:hover {
		border: 1px solid #222;
	}


    .modal.imagePool >>> .images .imgWrapper.selected .overlay {
        position: absolute;
        left: 0; right: 0;
        bottom: 0; top: 0;
        background: rgba(255,255,255,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .modal.imagePool >>> .images .imgWrapper.selected .overlay .icon {
        color: green;
    }
	.modal.imagePool .v-spinner {
		max-width: 100%;
	}
</style>
